import { AUTOPAY_LIMIT_OPTIONS } from '@features/PaymentsAndFinancial/Autopay/constants';

import type { AutopayState } from '../types/autopay.types';

export const initialState: AutopayState = {
  activeCardDetails: null,
  autopayCards: null,
  autopayLimitOption: {
    autopayLimit: '',
    daySurgeryLimit: '',
    daySurgeryLimitChecked: false,
    emergencyOPLimit: '',
    emergencyOPLimitChecked: false,
    inpatientLimit: '',
    inpatientLimitChecked: false,
    option: AUTOPAY_LIMIT_OPTIONS.asCharged,
  },
  autopayPayorDetails: null,
  cardDetails: [],
  isEditSummary: false,
  patientTypeOption: null,
  selectedCardId: null,
  selectedInstitution: null,
  selectedPatient: null,
  sourceOption: null,
};
